import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=2c64c2c0"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=2c64c2c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports